type statusResponse = number
type ResponseMessage = string;

export default function responseErrorMessage(status : statusResponse): ResponseMessage {
    let errorMessage: ResponseMessage = "";

    switch (status) {
        case  504 :
        case  502 :
        case  503 :
        case  524 :
            errorMessage = "Service Unavailable! Please try letter.";
            break;

        default:
            errorMessage = "Something went wrong. Please try again.";
    }

    return errorMessage;
}
